"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.form.label': '标签',
    'slotData.form.value': '值',
    'slotData.form.type': '类型',
};
